import { useContext } from "react";

import { Skeleton } from "@chakra-ui/react";

import { Flex, Tag } from "../../internal/exports";

import { ContributionContext } from "../context";

export function Tags() {
  const { tags, isLoaded, showTags } = useContext(ContributionContext);

  if (!showTags || !tags || tags.length === 0) return null;

  if (!isLoaded) {
    return <Skeleton h="20px" w="50%" borderRadius="md" />;
  }

  return (
    <Flex gap={2} wrap="wrap">
      {tags.map((tag: string) => (
        <Tag
          key={tag}
          colorPalette="gray"
          variant="subtle"
          style={{ direction: "rtl" }}
          data-testid="card-FooterTag"
        >
          {tag}
        </Tag>
      ))}
    </Flex>
  );
}
